export default "__VITE_ASSET__Dobey$pW__"